import { atom } from 'jotai'
import type { MediaAsset } from '../../views'
import { feedAdImageHistoryAtom, landingPageImageHistoryAtom, orgAssetsAtom, storyAdImageHistoryAtom } from '../state'

/**
 * Media IDs known to be AI-generated (media library collection `generated`).
 * Sourced from the org media index plus the per-ad image histories, so an
 * image is recognised even before the org index refetches after a generation.
 */
export const aiGeneratedMediaIdsAtom = atom<Set<string>>((get) => {
	const mediaIds = new Set<string>()

	const collect = (assets: Array<Pick<MediaAsset, 'id' | 'collection'>>) => {
		for (const asset of assets) {
			if (asset.collection === 'generated') {
				mediaIds.add(asset.id)
			}
		}
	}

	collect(get(orgAssetsAtom).media)
	collect(get(feedAdImageHistoryAtom))
	collect(get(storyAdImageHistoryAtom))
	collect(get(landingPageImageHistoryAtom))

	return mediaIds
})
